import { render, staticRenderFns } from "./PreviewLockedOverlay.vue?vue&type=template&id=8a8e18ca&scoped=true"
import script from "./PreviewLockedOverlay.vue?vue&type=script&lang=js"
export * from "./PreviewLockedOverlay.vue?vue&type=script&lang=js"
import style0 from "./PreviewLockedOverlay.vue?vue&type=style&index=0&id=8a8e18ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8e18ca",
  null
  
)

export default component.exports